// extracted by mini-css-extract-plugin
module.exports = {"boardWrapper":"Projects_boardWrapper__1Y6GP","boardBody":"Projects_boardBody__2yry8"};